module.exports = __webpack_public_path__ + "static/media/whiteMap.f8658efe.svg";